export const ONE_TIME_READ_SCALE_REQUEST = 'ONE_TIME_READ_SCALE_REQUEST';
export const oneTimeReadScaleRequest = (scale, requestId) => ({
  type: ONE_TIME_READ_SCALE_REQUEST,
  scale,
  requestId,
});
